<template>
  <div class="ranking-list-card-style1">
    <div class="card-header">
      <div class="card-header-left">
        <p class="card-header-title">{{title}}</p>
        <el-tooltip v-if="tooltip" effect="dark" :content="tooltip" placement="top" style="margin-left: 4px">
          <i class="QS-icon-question-outline"></i>
        </el-tooltip>
        <p class="card-header-dataDesc">{{dataDesc}}</p>
        <i class="separator"></i>
        <p class="card-header-dataUpdateTime">更新于{{dataUpdateTime}}</p>
      </div>
    </div>
    <div class="card-body">
      <div class="card-body-inner">
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <FiltersBox :filterList="filterList" :model.sync="filterModel" @change="handleFiltersChange" />

        <QS-common-table
          class="ranking-table"
          :columns="tableColumns"
          :data="tableData"
          :pagination="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FiltersBox from '@/bizComponents/Dashboard/filtersBox'

export default {
  components: {
    FiltersBox,
  },
  props: {
    // 标题
    title: {
      type: String,
      default: '',
    },
    // 提示语
    tooltip: {
      type: String,
      default: '',
    },
    // 数据描述
    dataDesc: {
      type: String,
      default: '',
    },
    // 数据更新时间
    dataUpdateTime: {
      type: String,
      default: '',
    },
    // 筛选项列表
    filterList: {
      type: Array,
      default: () => [],
    },
    // 筛选项对象
    filterModel: {
      type: Object,
      default: () => ({}),
    },
    // 表格列配置
    tableColumns: {
      type: Array,
      default: () => [],
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleFiltersChange(val) {
      this.$emit('filtersChange', val)
    },
  },
}
</script>

<style lang="scss" scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt12 {
  margin-top: 12px;
}
.ranking-list-card-style1 {
  border-radius: 2px;
  // overflow: hidden;
  .card-header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 38px;
    padding: 8px 12px;
    background: #F8F8FA;
    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -9px;
      content: '';
      width: 3px;
      height: 18px;
      background: #0256FF;
      border-radius: 10px;
    }
    .card-header-left {
      display: flex;
      align-items: center;
      .card-header-title {
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        color: #3D3D3D;
      }
      ::v-deep .QS-icon-question-outline {
        color: #C0C4CC;
      }
      .card-header-dataDesc {
        margin-left: 10px;
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
      .separator {
        width: 1px;
        height: 10px;
        margin: 0 6px;
        flex: none;
        background: #767676;
      }
      .card-header-dataUpdateTime {
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
    }
    .card-header-right {

    }
  }
  .card-body {
    .card-body-inner {
      display: flex;
      flex-direction: column;
      // justify-content: center;
      // align-items: center;
      padding: 16px 0 26px 0;
      // border-left: 1px solid #ECEEF4;
      // border-right: 1px solid #ECEEF4;
      // border-bottom: 1px solid #ECEEF4;
      .ranking-table {
        margin-top: 12px;
        ::v-deep .el-table__empty-block {
          border: none
        }
      }
    }
  }
}
</style>
